import Logger from './logger'
import config from './config'

window.Render = window.Render || {}

// Try to call `console.log`, if possible, in the way
// most likely to invoke pretty-printing
function safeLog(...args: Parameters<typeof globalThis.console.log>) {
  if (!('log' in window.console)) {
    return
  }

  return window.console.log(...args)
}

const logger = new Logger({
  loggerFn: safeLog,
  quiet: config.quiet,
})

export {logger}

// @ts-expect-error TS2322 `logger.debug` doesn't fully satisfy the type of
// `window.debug`, seeing as we need `.buffer` to exist as a static property
// as well. That despite that being added later here, ts cannot guarantee that
// this line is safe if it relied on other lines. Type narrowing is a newish
// concept to typescript, so maybe one day we'll get it — but not today. So lets
// expect an error than ignore it.
window.debug = logger.debug.bind(logger)
window.debug.buffer = () => logger.buffer
